import { render } from "./ChildFormProvider.vue?vue&type=template&id=93aa3eee&ts=true"
import script from "./ChildFormProvider.vue?vue&type=script&lang=ts"
export * from "./ChildFormProvider.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__